import loan from './loan/index';
import client from './client/index';

const models = {
    loan,
    client
};

export default models;